import api from "@/services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ListParams } from "../types/common";
import { SaveNavbarLinkPayload } from "../types/navbarLinkType";

export const getNavbarLinkList = createAsyncThunk("/navbarLink/list", async (params: ListParams = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.keyword) query.set("keyword", params.keyword);
  const response = (await api.get(`/navbarlinks?${query.toString()}`)).data;
  return response;
});

export const saveNavbarLink = createAsyncThunk("/navbarLink/save", async (payload: SaveNavbarLinkPayload) => {
  const response = (await api.post("/navbarlinks/action", payload)).data;
  return response;
});

export const deleteNavbarLink = createAsyncThunk("/navbarLink/delete", async (id: number) => {
  const response = (await api.get(`/navbarlinks/delete/${id}`)).data;
  return response;
});
